import { useState, useEffect, Fragment, useCallback, ChangeEvent } from 'react';
import { Modal, ModalBody } from 'react-bootstrap';
import { ResponseSuccessModal, ResponseFailModal } from '../../components/Modal/Response';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../stores';
import BlackUpdate from '../../components/BlackList/BlackUpdate';
import { changeField, changeResult, initialize, selectBlackListAction, updateBlackListAction } from '../../stores/blackList';
import { BlackUpdateContainerProps } from '../../types/blackList';

const BlackUpdateContainer = ({
  isOpen,
  toggle,
  reload,
  id,
}:BlackUpdateContainerProps) => {
  const dispatch = useDispatch();
  const { blackListItem, blackUpdateSuccess, blackUpdateError, } = useSelector(({ blackList }:RootState) => ({
      blackListItem: blackList.blackList,
      blackUpdateSuccess: blackList.blackUpdateSuccess,
      blackUpdateError: blackList.blackUpdateError,
  }));
  const [ isOpenBlackListUpdateSuccessModal, setIsOpenBlackListUpdateSuccessModal ] = useState<boolean>(false);
  const [ isOpenBlackListUpdateFailModal, setIsOpenBlackListUpdateFailModal ] = useState<boolean>(false);
  const [ isOpenRequiredParameterFailModal, setIsOpenRequiredParameterFailModal ] = useState<boolean>(false);
  const [ messageBlackListUpdateFail, setMessageBlackListUpdateFail ] = useState<string>('');

  //인풋 변경 이벤트 핸들러
  const handleChange = useCallback((e:ChangeEvent<HTMLInputElement>|ChangeEvent<HTMLSelectElement>) => {
    const { value, name } = e.target;
    dispatch(
        changeField({
            key: name,
            value: value,
        })
    );
  },[dispatch]);
  
  const handleUpdateBlackList = useCallback(() => {
    if (!blackListItem.room_no){
      setIsOpenRequiredParameterFailModal(true); 
      return;
    }
    dispatch(updateBlackListAction({...blackListItem, id}));
  },[id, blackListItem, dispatch]);

  useEffect(() => {
    if (isOpen){
      //화면이 나타날 때 초기화
      dispatch(initialize());
      // dispatch(listBlackAction());
      dispatch(selectBlackListAction({id}));
      setIsOpenBlackListUpdateFailModal(false);
      setIsOpenBlackListUpdateSuccessModal(false);
    }
  }, [id, dispatch, isOpen]);
  
  useEffect(() => {
    if(blackUpdateError){
      if (!blackUpdateError.response){
        setMessageBlackListUpdateFail(blackUpdateError.message);
        setIsOpenBlackListUpdateFailModal(true);
      }else{
        if (blackUpdateError.response.data === undefined){
          setMessageBlackListUpdateFail(blackUpdateError.message);
        }else{
          setMessageBlackListUpdateFail(`${blackUpdateError.response.data.code}, ${blackUpdateError.response.data.message}`);
          if(blackUpdateError.response.data?.code === 401 || blackUpdateError.response.data?.code === 419) reload();
        }
        setIsOpenBlackListUpdateFailModal(true);
      }
      dispatch(changeResult({
        key: 'blackUpdateError',
        value: null,
      }));
      return;
    }
    if(blackUpdateSuccess){
      toggle();
      setIsOpenBlackListUpdateSuccessModal(true);
      setTimeout(() => {
        setIsOpenBlackListUpdateSuccessModal(false);
        reload();
      }, 1500);
      dispatch(initialize()); //hotel.ts 전역상태 초기화
    }
  },[blackUpdateSuccess, blackUpdateError, toggle, reload, dispatch]);


  return (
    <Fragment>
      <Modal
        show={isOpen}
        onHide={() => toggle()}
        centered
        backdrop='static'
      >
        <ModalBody className='text-center m-3' style={{margin:0, padding:0}}>
          <BlackUpdate 
            blackListItem={blackListItem}
            handleChange={handleChange}
            handleUpdateBlackList={handleUpdateBlackList}
            toggle={toggle}
          />
        </ModalBody>
      </Modal>
      <ResponseSuccessModal
        isOpen={isOpenBlackListUpdateSuccessModal}
        toggle={() => setIsOpenBlackListUpdateSuccessModal(!isOpenBlackListUpdateSuccessModal)}
        message='객실 정보 수정이 완료 되었습니다.'
      />
      <ResponseFailModal
        isOpen={isOpenBlackListUpdateFailModal}
        toggle={() => setIsOpenBlackListUpdateFailModal(!isOpenBlackListUpdateFailModal)}
        message={messageBlackListUpdateFail || '객실 정보 수정에 실패 하였습니다.'}
      />
      <ResponseFailModal
        isOpen={isOpenRequiredParameterFailModal}
        toggle={() => setIsOpenRequiredParameterFailModal(!isOpenRequiredParameterFailModal)}
        message='필수 입력값을 확인 해주세요.'
      />
    </Fragment>
  );
};

export default BlackUpdateContainer;